var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Mixins } from 'vue-property-decorator';
import VeeValidate, { Validator } from 'vee-validate';
import { ProfileService } from '@/services/profile-service';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import LayoutMixin from '@/mixins/layout-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
Vue.use(VeeValidate);
Validator.extend('password_strength', {
    getMessage: function (field, args) {
        return 'Password does not meet the requirements shown';
    },
    validate: function (value, args) {
        var isValidLength = String(value).length >= 8;
        var containsLowercaseRegex = /(?=.*[a-z])/g;
        var containsUppercaseRegex = /(?=.*[A-Z])/g;
        var containsNumberRegex = /(?=.*\d)/g;
        var containsSpecialCharacterRegex = /(?=.*\W])/g;
        var isContainingLowercase = containsLowercaseRegex.test(value);
        var isContainingUppercase = containsUppercaseRegex.test(value);
        var isContainingNumber = containsNumberRegex.test(value);
        var isContainingSpecialCharacter = containsSpecialCharacterRegex.test(value);
        var specialCaseCount = 0;
        specialCaseCount += isContainingLowercase ? 1 : 0;
        specialCaseCount += isContainingUppercase ? 1 : 0;
        specialCaseCount += isContainingNumber ? 1 : 0;
        specialCaseCount += isContainingSpecialCharacter ? 1 : 0;
        return isValidLength && specialCaseCount >= 3;
    },
});
var ChangePassword = /** @class */ (function (_super) {
    __extends(ChangePassword, _super);
    function ChangePassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.showNewPassword = false;
        _this.showConfirmPassword = false;
        _this.submitLoading = false;
        _this.validationRules = {
            newPassword: { required: true, password_strength: true },
            confirmPassword: { required: true, confirmed: 'newPassword' },
        };
        return _this;
    }
    ChangePassword.prototype.validate = function (scope) {
        var _this = this;
        this.$validator.validateAll(scope).then(function (result) {
            if (result) {
                _this.save();
            }
        });
    };
    ChangePassword.prototype.created = function () {
        this.item = this.profileService.getDefaultChangePasswordVm();
    };
    ChangePassword.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.submitLoading = true;
                        return [4 /*yield*/, this.profileService.saveChangePasswordVm(this.item.newPassword)];
                    case 1:
                        response = _a.sent();
                        this.item.newPassword = '';
                        this.item.confirmPassword = '';
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        this.showSnackbar({ text: 'Password updated', color: 'success' });
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this.showSnackbar({ text: 'Unable to update password', color: 'error' });
                        return [3 /*break*/, 4];
                    case 3:
                        this.submitLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var _a;
    __decorate([
        lazyInject(TYPES.ProfileService),
        __metadata("design:type", typeof (_a = typeof ProfileService !== "undefined" && ProfileService) === "function" ? _a : Object)
    ], ChangePassword.prototype, "profileService", void 0);
    ChangePassword = __decorate([
        Component({
            $_veeValidate: { validator: 'new' },
        })
    ], ChangePassword);
    return ChangePassword;
}(Mixins(LayoutMixin, SnackbarMixin)));
export default ChangePassword;
